import { Column } from '~components/table-view-v3';

const columns: Column[] = [
  {
    id: 'name',
    header: 'Name',
    type: 'text',
  },
  {
    id: 'code',
    header: 'Account Code',
    type: 'text',
  },
  {
    id: 'allow_supplier_invoice',
    header: 'Allow Invoicing?',
    type: 'checkbox',
    style: { width: '175px' },
  },
  {
    id: 'allow_supplier_reimburse',
    header: 'Allow Reimbursing?',
    type: 'checkbox',
    style: { width: '175px' },
  },
];

export default columns;
